import { faInfoCircle, faTimes } from "@fortawesome/pro-regular-svg-icons";

import { Divider } from "src/base-components/Divider";
import { Button } from "src/design-system/Button";
import { Icon, IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";
import { SchemaEditorSidebarProps } from "src/schema/schemaEditor/types";

export const SchemaEditorSidebar: React.FC<SchemaEditorSidebarProps> = ({
  canSave,
  isSaving,
  schema,
  onClose,
  title,
  tooltipText,
  children,
}) => {
  return (
    <div className="decideScrollbar flex h-full w-150 shrink-0 flex-col gap-y-4 border-gray-100 border-l bg-white pb-5">
      <div className="sticky top-0 z-20 flex flex-col gap-y-4 bg-white px-4 pt-5">
        <div className="flex items-center gap-x-1.5">
          <div className="flex-1 font-inter-semibold-13px text-gray-800">
            {title}
          </div>
          <Button
            isDisabled={!schema || !canSave || isSaving}
            htmlType="submit"
            isLoading={isSaving}
            size="sm"
          >
            Save changes
          </Button>
          <Tooltip body={tooltipText} placement="top-end">
            <Icon icon={faInfoCircle} size="xs" />
          </Tooltip>
          <IconButton icon={faTimes} size="xs" onClick={onClose} />
        </div>
        <Divider />
      </div>
      <div className="flex flex-col gap-y-4 px-4">{children}</div>
    </div>
  );
};
